import { Model } from "./Model";
import {
  Municipio,
  MunicipioValidation,
  MunicipioNoValidation,
} from "./Municipio";
import { required } from "vuelidate/lib/validators";

class Endereco extends Model {
  constructor() {
    super();
    this.bairro = "";
    this.cep = "";
    this.complemento = "";
    this.logradouro = "";
    this.municipio = new Municipio();
    this.numero = "";
    this.referencia = "";
    this.fone = "";
  }
}

const EnderecoValidation = {
  bairro: { required },
  cep: { required },
  complemento: {},
  logradouro: { required },
  municipio: MunicipioValidation,
  numero: { required },
  referencia: {},
  fone: {},
};

const EnderecoNoValidation = {
  bairro: {},
  cep: {},
  complemento: {},
  logradouro: {},
  municipio: MunicipioNoValidation,
  numero: {},
  referencia: {},
  fone: {},
};

export { Endereco, EnderecoValidation, EnderecoNoValidation };
